import type { App, InjectionKey } from 'vue';
import type { Router } from 'vue-router';
import { useRouterProgressLoader } from '.';
import { ProgressLoader, useProgressLoader } from './composables/useProgressLoader';

export const APP_PROGRESS_LOADER_KEY: InjectionKey<ProgressLoader> = Symbol('AppProgressLoader');

export interface ProgressLoaderInstallOptions {
	router?: Router,
}

export const createAppProgressLoader = () => {
	const progressLoader = useProgressLoader();

	const install = (app: App, options?: ProgressLoaderInstallOptions) => {
		app.provide(APP_PROGRESS_LOADER_KEY, progressLoader);

		if (options && options.router) {
			useRouterProgressLoader(progressLoader, options.router);
		}
	};

	return {
		...progressLoader,
		install,
	};
};
